import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductDetailsModalComponent } from './product-details-modal.component';
import { ProductInfoModule } from '../product-details/product-info/product-info.module';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  declarations: [ProductDetailsModalComponent],
  imports: [
    CommonModule,
    ProductInfoModule,
    ModalModule.forRoot()
  ]
})
export class ProductDetailsModalModule { }
